import Subheader from 'app/frontend/base/components/Subheader'
import {
  usePageInfo,
  useUserApplicationSummary,
} from 'app/frontend/base/config/queries'
import { useHasSidebar } from 'app/frontend/base/helpers'
import { useTranslation } from 'react-i18next'

const UserSubheader = () => {
  const { t } = useTranslation()
  const {
    data: { user },
  } = usePageInfo()
  const hasSidebar = useHasSidebar()

  const { data: applicationSummary, isPending } = useUserApplicationSummary()

  if (!user) return null

  return (
    <Subheader
      fullWidth={hasSidebar}
      menuItems={[
        {
          name: t('profile.header.linked-accounts'),
          path: `/profile`,
          exact: true,
          width: 94,
        },
        {
          name: t('profile.header.characters'),
          path: `/profile/characters`,
          width: 76,
        },
        {
          name: t('profile.header.premium'),
          path: `/profile/premium`,
          width: 87,
        },
        {
          name: (
            <div
              className={`flex items-center justify-center gap-1.5 md:w-26 ${
                isPending ? 'opacity-0' : 'opacity-100'
              }`}
            >
              <span>{t('profile.header.applications')}</span>
              <span className='text-muted-foreground text-xs max-md:hidden'>
                ({Object.keys(applicationSummary ?? {}).length ?? 0})
              </span>
            </div>
          ),
          path: `/profile/applications`,
          width: 87,
        },
        {
          name: t('profile.header.settings'),
          path: `/profile/settings`,
          width: 76,
        },
      ]}
    />
  )
}

export default UserSubheader
